define('constants/audioInputOptionConstants',[], function() {
    return {
        record : "record",
        upload : "upload",
    };
});
